import { useState } from "react";
import { Text, Button, Dialog, Icon, Chip } from '@ui-component-library';
import { PlusSubscription } from './Settings.types';
import { cancelDFRRenewal } from '@services/subscription';
import { formatDateSwedish } from '@vb-django/components/minskog/utils';

export default function PlusSubscriptionRow({ sub, onCancelled }: { sub: PlusSubscription; onCancelled: () => void }) {
    const [loading, setLoading] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [error, setError] = useState(null);
  
    async function handleCancelRenewal() {
      setLoading(true);
      const resp = await cancelDFRRenewal(sub.id);
      setLoading(false);
      if (resp.ok) {
        setConfirmOpen(false);
        onCancelled();
      } else {
        setConfirmOpen(false);
        setError(resp.error);
        setTimeout(() => setError(null), 2000);
      }
    }

  
    return (
      <div className="p-6 flex flex-col lg:flex-row lg:items-start lg:justify-between hover:bg-cloud-50/50 transition-colors gap-4">
        <div className="flex flex-col gap-1">        
          {error && (
            <div className="rounded-lg bg-danger-500 border border-danger-500 px-4 py-3 mb-1 text-sm text-danger-1000">
                Något gick fel när vi försökte avsluta autoförnyelsen. Försök igen senare.
            </div>
            )}
          <div className="flex items-center gap-2">
            <Text variant="text-sm/leading-normal/medium" className="text-charcoal-1000">
              {sub.designation || sub.ref || 'Treebula Plus'}
            </Text>
            <Chip
               label="Aktiv"
               className="bg-green-100 text-green-700"
               icon="SparkleFilled"
             />
        
            {sub.auto_renew && (

               <Chip
               label="Autoförnyas"
               className="bg-blue-100 fill-blue-700 text-blue-700"
               icon="ClockSimple"
             />
            )}
          </div>
          <Text variant="text-xs/leading-normal/normal" className="text-charcoal-500">
            Från: {formatDateSwedish(new Date(sub.start_time))}
          </Text>
          <Text variant="text-xs/leading-normal/normal" className="text-charcoal-500">
            Till: {formatDateSwedish(new Date(sub.end_time))}
          </Text>
        </div>
  
        {sub.auto_renew && (
          <>
            <div className="flex flex-col gap-2 lg:items-end">
              <Button
                variant="secondary"
                size="small"
                onClick={() => setConfirmOpen(true)}
              >
                Avsluta autoförnyelse
              </Button>
            </div>
            <Dialog
              isOpen={confirmOpen}
              onClose={() => {
                if (!loading) setConfirmOpen(false);
              }}
              size="small"
            >
              <Dialog.Header className="items-start justify-between">
                <Text variant="text-base/leading-normal/medium">Avsluta autoförnyelse?</Text>
                <Button
                  variant="outline"
                  size="icon"
                  ariaLabel="Stäng"
                  disabled={loading}
                  onClick={() => setConfirmOpen(false)}
                >
                  <Icon name="CrossSimple" className="color-charcoal-500" size="medium" />
                </Button>
              </Dialog.Header>
              <Dialog.Content>
                <Text variant="text-xs/leading-normal/normal" className="text-charcoal-700">
                  Är du säker? Prenumerationen löper ut {formatDateSwedish(new Date(sub.end_time))} och förnyas
                  inte.
                </Text>
              </Dialog.Content>
              <Dialog.Footer>
                <Button variant="secondary" size="small" onClick={() => setConfirmOpen(false)} disabled={loading}>
                  Avbryt
                </Button>
                <Button variant="primary" size="small" onClick={handleCancelRenewal} disabled={loading}>
                  {loading ? 'Sparar...' : 'Ja, avsluta'}
                </Button>
              </Dialog.Footer>
            </Dialog>
          </>
        )}
      </div>
    );
}

